import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import { TextField, Button, Slide, Dialog, AppBar, IconButton, Typography, Toolbar, Box } from '@material-ui/core';
import TeamMembersTable from '../TeamMembers/TeamMembersTable';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';
import 'toastr/build/toastr.min.css';
import { DisplayMessage, GetFormattedDate } from '../../../../services/helpers.js';
import FormControl from '@material-ui/core/FormControl';
import Paper from '@material-ui/core/Paper';
import { SelectTheme } from '../../../../utils/utils.js';
import { ThemeProvider } from "@material-ui/core";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Redirect } from 'react-router-dom';
import CloseIcon from '@material-ui/icons/Close';
import appFetch from '../../../../api/appFetch.js';
import { PlanningTeamsUrl, PlanningTeamsWithIdUrl } from '../../../../constants/apiUrls.js';
import OutletsDropdown from '../../../Common/Dropdowns/OutletsDropdown.js';
import TeamsDropdown from '../../../Common/Dropdowns/TeamsDropdown.js';
import EnhancedDropdownComponent from '../../../Common/Dropdowns/EnhancedDropdownComponent.js';
import DatePickerComponent from '../../../Common/DatePickers/DatePickerComponent.js';
import ModifiedByInfo from "./../../../Common/Footers/ModifiedByInfo";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default class TeamNew extends Component {
    constructor(props) {
        super(props);
        var editedTeamId = undefined;
        if (this.props !== undefined) {
            editedTeamId = this.props.teamId;
        }

        this.state = {
            id: 0,
            outletId: 0,
            outletName: "",
            dmsIndicator: "",
            hasWorkPreparation: false,
            description: "",
            activeFrom: "",
            activeTill: "",
            parentTeamId: 0,
            createdOn: "",
            createdByName: "",
            createdByAvatar: "",
            selectedOutletId: 0,
            loading: false,
            redirect: false,
            accessibleMoboOutlets: [],
            parentTeams: [],
            teamMembers: [],
            editedTeamId: editedTeamId,
            requestInProgress: false,
            type: 0,
            openEditPopup: true,
            showEditTeam: false,
            teamWasCreated: false,
            teamWasUpdated: false,
        };
    }

    componentWillMount() {
        if (this.state.editedTeamId !== undefined) {
            this.getTeamById(this.state.editedTeamId);
        }
    }

    handleChange = e => {
        var value = e.target.value;
        if (value.replace) {
            value = value.replace(/^\s+/, "");
        }
        this.setState({ [e.target.name]: value });
    };

    handleChangeOutlet = e => {
        this.setState({ outletId: e.target.value });
    };

    handleChangeCheckBox = e => {
        this.setState({ [e.target.name]: e.target.checked });
    };

    handleSubmit = () => {
        if (this.state.id === 0) {
            this.saveNewTeam();
        }
        else {
            this.saveEditedTeam();
        }
    }

    getTeamById = (teamId) => {
        const url = PlanningTeamsWithIdUrl(teamId);

        appFetch({
            url: url,
            onSuccess: (data) => {
                if (data.id !== undefined) {
                    this.setState({
                        id: data.id,
                        outletId: data.outletId,
                        outletName: data.outletName,
                        dmsIndicator: data.dmsIndicator != null ? data.dmsIndicator : "",
                        hasWorkPreparation: data.hasWorkPreparation,
                        description: data.description,
                        type: data.type,
                        loading: false,
                        activeFrom: GetFormattedDate(data.activeFrom),
                        activeTill: GetFormattedDate(data.activeTill),
                        parentTeamId: data.parentTeam !== null ? data.parentTeam.id : 0,
                        createdOn: data.createdOn,
                        createdByName: data.createdByName,
                        createdByAvatar: data.createdByAvatar,
                        teamMembers: data.members
                    });
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    isValidForm = () => {
        const { description, outletId, type, activeFrom, activeTill } = this.state;

        if (!description || description.trim().length === 0) {
            return false;
        }

        if (!outletId) {
            return false;
        }

        if (!parseInt(type)) {
            return false;
        }

        if (!activeFrom) {
            return false;
        }

        if (activeTill) {
            const momentActiveFrom = moment(activeFrom, 'YYYY/MM/DD');
            const momentActiveTill = moment(activeTill, 'YYYY/MM/DD');

            if (!momentActiveFrom.isValid() || !momentActiveTill.isValid() || !momentActiveTill.isAfter(momentActiveFrom)) {
                return false;
            }
        }

        return true;
    }

    saveNewTeam = () => {
        let resources = this.props.resources;

        let activeFrom = GetFormattedDate(this.state.activeFrom === "" ? undefined : this.state.activeFrom);
        let activeTill = GetFormattedDate(this.state.activeTill === "" ? undefined : this.state.activeTill);
        if (this.state.description.trim().length <= 0) {
            DisplayMessage(resources["InvalidDescripton"], "error");
            return;
        }

        if (activeFrom >= activeTill) {
            DisplayMessage(resources["InvalidEndDate"], "error");
            return;
        }

        if (this.state.dmsIndicator.length > 0 && this.state.dmsIndicator.trim().length <= 0) {
            DisplayMessage(resources["InvalidDmsIndicator"], "error");
            return;
        }

        this.setState({ requestInProgress: true });

        var json = JSON.stringify({
            outletId: this.state.outletId,
            description: this.state.description !== "" ? this.state.description : null,
            type: this.state.type,
            id: this.state.id,
            dmsIndicator: this.state.dmsIndicator !== "" ? this.state.dmsIndicator : null,
            hasWorkPreparation: this.state.hasWorkPreparation,

            activeFrom: activeFrom,
            activeTill: activeTill,
            parentTeamId: this.state.parentTeamId > 0 ? this.state.parentTeamId : null,
        });

        const url = PlanningTeamsUrl();

        appFetch({
            url: url,
            method: 'POST',
            body: json,
            onSuccess: (data) => {
                if (data.id !== undefined) {
                    this.setState({
                        id: data.id,
                        outletName: data.outletName,
                        dmsIndicator: data.dmsIndicator,
                        hasWorkPreparation: data.hasWorkPreparation,
                        description: data.description,
                        type: data.type,

                        activeFromsOn: GetFormattedDate(data.activeFrom),
                        activeTill: GetFormattedDate(data.activeTill),
                        parentTeamId: data.parentTeam !== null ? data.parentTeam.id : 0,
                        createdOn: data.createdOn,
                        createdByName: data.createdByName,
                        createdByAvatar: data.createdByAvatar,
                        teamMembers: data.members,
                        editedTeamId: data.id
                    });

                    DisplayMessage(resources["NewTeamWasSaved"], "success");
                    this.setState({ teamWasCreated: true, editedTeamId: data.id });
                }
            },
            onError: (data) => {
                for (let i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    saveEditedTeam = () => {
        let resources = this.props.resources;

        let activeFrom = GetFormattedDate(this.state.activeFrom);
        let activeTill = GetFormattedDate(this.state.activeTill);

        if (this.state.description.trim().length <= 0) {
            DisplayMessage(resources["InvalidDescripton"], "error");
            return;
        }
        if (activeFrom >= activeTill) {
            DisplayMessage(resources["InvalidEndDate"], "error");
            return;
        }

        if (this.state.dmsIndicator.length > 0 && this.state.dmsIndicator.trim().length <= 0) {
            DisplayMessage(resources["InvalidDmsIndicator"], "error");
            return;
        }

        this.setState({ requestInProgress: true });

        var json = JSON.stringify({
            outletId: this.state.outletId,
            description: this.state.description,
            type: this.state.type,
            id: this.state.id,
            dmsIndicator: this.state.dmsIndicator !== "" ? this.state.dmsIndicator : null,
            hasWorkPreparation: this.state.hasWorkPreparation,
            activeTill: activeTill,
            activeFrom: activeFrom,
            parentTeamId: this.state.parentTeamId > 0 ? this.state.parentTeamId : null,
        });

        const url = PlanningTeamsWithIdUrl(this.state.id);

        appFetch({
            url: url,
            method: 'PUT',
            body: json,
            onSuccess: (data) => {
                if (data.id !== undefined) {
                    this.setState({
                        id: data.id,
                        outletName: data.outletName,
                        dmsIndicator: data.dmsIndicator != null ? data.dmsIndicator : "",
                        hasWorkPreparation: data.hasWorkPreparation,
                        description: data.description,
                        type: data.type,
                        startactiveFromsOn: GetFormattedDate(data.activeFrom),
                        activeTill: GetFormattedDate(data.activeTill),
                        parentTeamId: data.parentTeam !== null ? data.parentTeam.id : 0,
                        createdOn: data.createdOn,
                        createdByName: data.createdByName,
                        createdByAvatar: data.createdByAvatar,
                        teamWasUpdated: true
                    });

                    DisplayMessage(resources["TeamWasSaved"], "success");
                }
            },
            onError: (data, response) => {
                if (response.statusText.length > 0) {
                    DisplayMessage(response.statusText, "error");
                }

                for (let i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    handleActiveFrom = value => {
        this.setState({ activeFrom: value });
    };

    handleActiveTill = value => {
        this.setState({ activeTill: value });
    };

    renderCreatedByInfo = () => {
        if (this.state.id > 0) {
            return (
                <ModifiedByInfo
                  resources={this.props.resources}
                  modifiedByAvatar={this.state.createdByAvatar}
                  modifiedOn={this.state.createdOn}
                  modifiedByName={this.state.createdByName}
                  className="mt-3"
                  isCreated={true}
                />
              );
        }
        return;
    }

    handleClose = () => {
        this.setState({ openEditPopup: false, redirect: "/teams" });
    }

    renderMembers = () => {
        if (this.state.id > 0) {
            return (
                <Paper elevation={3} className="p-4 mt-3 mb-3">
                    <Form.Group style={{ display: "flex" }}>
                        <div className="col-md-12" style={{ textAlign: "center" }} >
                            <TeamMembersTable
                                teamMembers={this.state.teamMembers}
                                key={this.state.teamMembers}
                                teamId={this.state.id}
                                editedTeamId={this.state.editedTeamId}
                                getTeamById={this.getTeamById}
                                resources={this.props.resources}
                            />
                        </div>
                    </Form.Group>
                </Paper>);
        }
        return;
    }

    formatDate(date) {
        return date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate();
    }

    renderForm() {
        const { redirect, editedTeamId, teamWasCreated, teamWasUpdated, hasWorkPreparation } = this.state;

        if (redirect) {
            return <Redirect to={{ pathname: this.state.redirect, state: { refreshGrid: teamWasCreated || teamWasUpdated, teamWasCreated } }} />
        }

        var resources = this.props.resources;
        var isDisalbed = editedTeamId > 0;
        var helperTextActiveFrom = this.state.activeFrom === "" ? "helper-text-red" : "helper-text-grey";
        return (
            <div>
                <Paper elevation={3} className="p-4 mt-3 mb-3">
                    <Form.Group className="pt-3" style={{ display: "flex" }} >
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField required className={"col-6 " + (this.state.description.trim().length < 1 ? "helper-text-red" : "helper-text-grey")} id="teams-description"
                                value={this.state.description}
                                label={resources["Description"]}
                                helperText={resources["InputOfDescriptionIsMandatory"]}
                                variant="outlined" name="description"
                                onChange={this.handleChange} inputProps={{ maxLength: 100 }} InputLabelProps={{ required: false }} />
                        </ThemeProvider>
                        <div className="col-3"></div>
                    </Form.Group>

                    <Form.Group style={{ display: "flex" }}>
                        <div className="col-3"></div>
                        <OutletsDropdown
                            resources={resources}
                            outlets={this.props.accessibleMoboOutlets}
                            outlet={this.state.outletId}
                            onOutletChange={this.handleChangeOutlet}
                            id="outlet-dropdown"
                            containerClass="col-6"
                            defaultValue={resources["SelectOutlet"]}
                            helperText={resources["SelectionOfOutletIsMandatory"]}
                            required
                            disabled={this.props.teamId > 0}
                        />
                        <div className="col-3"></div>
                    </Form.Group>
                    <Form.Group style={{ display: "flex" }}>
                        <div className="col-3"></div>
                        <div className="col-6" style={{ padding: 0 }}>
                            <EnhancedDropdownComponent
                                id="type-dropdown"
                                labelText={resources["Type"]}
                                value={this.state.type}
                                options={[
                                    { key: 1, name: resources["TeamTypeWorkshop"] },
                                    { key: 2, name: resources["TeamTypeTyreChanges"] },
                                    { key: 3, name: resources["TeamTypePDI"] },
                                ]}
                                inputName="type"
                                handleChange={this.handleChange}
                                addMarginBottom={false}
                                placeholder={resources["Select"]}
                                helperText={resources["SelectionOfTypeIsMandatory"]}
                                error={!this.state.type}
                                required
                            />
                        </div>
                        <div className="col-3"></div>
                    </Form.Group>
                    <Form.Group style={{ display: "flex" }}>
                        <div className="col-3"></div>
                        <TeamsDropdown
                            resources={resources}
                            team={this.state.parentTeamId}
                            teams={this.props.teams}
                            onTeamChange={this.handleChange}
                            onRequestStart={() => this.setState({ requestInProgress: true })}
                            onRequestEnd={() => this.setState({ requestInProgress: false })}
                            filter={t => t.outletId === this.state.outletId}
                            containerClass="col-6"
                            defaultValue={resources["DefaultDropdownValue"]}
                            inputName='parentTeamId'
                            helperText={resources["OptionallySetAParentTeam"]}
                            labelText={resources["ParentTeam"]}
                        />
                        <div className="col-3"></div>
                    </Form.Group>

                    <Form.Group style={{ display: "flex" }} >
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className="col-6" id="teams-dms-indicator" value={this.state.dmsIndicator} label={resources["DmsIndicator"]} variant="outlined" name="dmsIndicator" onChange={this.handleChange} inputProps={{ maxLength: 25 }} />
                        </ThemeProvider>
                        <div className="col-3"></div>
                    </Form.Group>
                    <Form.Group style={{ display: "flex" }} >
                        <div className="col-md-3 "> </div>
                        <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                            control={<Checkbox id="team-has-work-preparation" checked={hasWorkPreparation} onChange={this.handleChangeCheckBox} name="hasWorkPreparation" color="primary" />}
                            label={resources["HasWorkPreparation"]} />
                        <div className="col-md-4"> </div>
                    </Form.Group>

                    <Form.Group style={{ display: "flex", width: "100%", justifyContent: "center" }}    >
                        <Box display="flex" justifyContent="space-between" className='col-6' padding="0" style={{ gap: "15px" }}>
                            <DatePickerComponent
                                id="dateActiveFrom"
                                label={resources["ActiveFrom"]}
                                value={this.state.activeFrom}
                                onChange={this.handleActiveFrom}
                                error={!this.state.activeFrom}
                                helperText={resources["PleasePickADate"]}
                                minDate={new Date("2000-01-01")}
                                required
                            />
                            <DatePickerComponent
                                id="dateActiveTill"
                                label={resources["ActiveTill"]}
                                value={this.state.activeTill}
                                onChange={this.handleActiveTill}
                                helperText={resources["PleasePickADate"]}
                                minDate={new Date("2000-01-01")}
                            />
                        </Box>
                    </Form.Group>

                    {this.renderCreatedByInfo()}
                </Paper>
                {this.renderMembers()}
            </div>
        );
    }

    render() {
        const { redirect, requestInProgress, openEditPopup, editedTeamId, teamWasCreated, teamWasUpdated, loading } = this.state;

        if (redirect) {
            return <Redirect to={{ pathname: this.state.redirect, state: { refreshGrid: teamWasCreated || teamWasUpdated, teamWasCreated } }} />
        }

        var resources = this.props.resources;

        const handleSubmit = (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.handleSubmit();
        };

        if (loading) {
            return (<div className="centered-loader"><CircularProgress /></div>)
        }

        const isSaveButtonDisabled = requestInProgress || !this.isValidForm() || redirect;

        return (
            <Dialog fullScreen open={openEditPopup} onClose={this.handleClose} TransitionComponent={Transition}>
                <Form onSubmit={handleSubmit} onKeyPress={event => {
                    if (event.which === 13) {
                        event.preventDefault();
                    }
                }}>
                    <AppBar className="position-sticky ">
                        <Toolbar>
                            <IconButton edge="start" id="close-edit-team" color="inherit" onClick={this.handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" style={{ flex: 1 }}>
                                {editedTeamId !== undefined ? resources["EditTeam"] : resources["AddNewTeamTitle"]}
                            </Typography>
                            <Button id="team-save" color="inherit" type="submit" disabled={isSaveButtonDisabled}>{resources["Save"]}</Button>

                        </Toolbar>
                    </AppBar>
                    <div className="container">
                        <div className={"py-4 grey" + (this.state.loading ? 'fadeOut' : 'fadeIn')}>
                            {this.renderForm()}
                        </div>
                    </div>
                </Form >
            </Dialog >
        );
    }
}